export const Genders = {1: "Muž", 2: "Žena", 3: "Jiné", 0: "Neznámé"};
export const WorkStates = {0: "Připravovaná", 1: "Běžící", 2: "Nepodařená", 3: "Odevzdaná", 4:"Zhodnocená", 5: "Úspěšná", 6: "Neobhájená"};

export const ADMIN_ROLE = "theses_admin";
export const EVALUATOR_ROLE = "theses_evaluator";
export const MANAGER_ROLE = "theses_manager";